import LazyLoaderFactory from './lazyLoader';

function Selecter(props) {
    return (
        <LazyLoaderFactory module={import(/* webpackChunkName: "selecter" */ '../theme/selecter')}
                           props={props}/>
    );
}

export default Selecter;
